import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import { ErrorBoundarySuspense } from '@/components/error-boundary-suspense';
import { usePurchaseOrders } from './hooks/use-purchase-orders';
import { PurchaseOrdersTable } from './purchase-orders-table';

export function PurchaseOrders() {
  const { t } = useTranslation('purchaseOrders');
  const { queryKey } = usePurchaseOrders();
  const navigate = useNavigate();

  return (
    <div className='flex min-h-0 flex-1 flex-col'>
      <ErrorBoundarySuspense
        errorFallbackWrapper={<div className='mt-4 w-full max-w-md' />}
        loadingFallback={
          <DataTableSkeleton columnCount={7} filterCount={3} rowCount={8} />
        }
        message={t('Unable to load purchase orders')}
        queryKey={queryKey}
      >
        <PurchaseOrdersTable
          onPurchaseOrderClick={(purchaseOrderId) => {
            navigate({
              to: '/purchase-orders/$id',
              params: { id: purchaseOrderId },
            });
          }}
        />
      </ErrorBoundarySuspense>
    </div>
  );
}
